import { render, staticRenderFns } from "./unionPriceLevelSort.vue?vue&type=template&id=a2c583fc&"
import script from "./unionPriceLevelSort.vue?vue&type=script&lang=js&"
export * from "./unionPriceLevelSort.vue?vue&type=script&lang=js&"
import style0 from "./unionPriceLevelSort.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionPriceLevelSort.vue"
export default component.exports